import { type JourneyType, Journeys } from '@atlassiansox/cross-flow-api-internals';
import type { ViewState } from './types';
import {
	getBenefitsPageRoute,
	getDiscoverProductsPageRoute,
} from '@atlassiansox/product-store-react';
import type { TargetType } from '@atlassiansox/cross-flow-base-types';

export const getInitialState = ({
	journey,
	targetProduct,
	sourceContext,
	sourceComponent,
}: {
	journey?: JourneyType;
	targetProduct?: TargetType;
	sourceComponent: string;
	sourceContext: string;
}): ViewState => {
	switch (journey) {
		case Journeys.GET_STARTED: {
			if (targetProduct === undefined) {
				throw new Error('Missing Target Product');
			}
			return {
				spa: 'cross-flow-frontend',
				route: getBenefitsPageRoute(targetProduct),
				targetProduct,
				sourceComponent,
				sourceContext,
			};
		}
		case Journeys.DECIDE: {
			if (targetProduct === undefined) {
				throw new Error('Missing Target Product');
			}
			return {
				spa: 'product-store',
				route: getBenefitsPageRoute(targetProduct),
				targetProduct,
				sourceComponent,
				sourceContext,
			};
		}
		case Journeys.DISCOVER:
		default: {
			return {
				spa: 'product-store',
				route: getDiscoverProductsPageRoute(),
				sourceComponent,
				sourceContext,
			};
		}
	}
};
